import * as userDomain from "@/domain/user"
import { UserItem } from "@/molecules/UserItem"

export const UserCell = (name: string) => (
  <UserItem
    ghost
    avatarSize="small"
    email={name}
    initials={userDomain.getInitials(name)}
    colorNumber={userDomain.getColorNumberForUserAvatar(name)}
  />
)
